'use strict';

import React from 'react';

import {
  Button,
  Container,
  Stack,
  Typography
} from '@mui/material';

import { useNavigate } from 'react-router-dom';

export default function NoEncontrado() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 10 }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Typography
          variant="h1"
          fontWeight={950}
          sx={{ letterSpacing: '-0.05em' }}
        >
          404
        </Typography>

        <Typography variant="h5" fontWeight={900}>
          Página no encontrada
        </Typography>

        <Button
          variant="contained"
          onClick={() => navigate('/')}
          sx={{
            borderRadius: 999,
            px: 3,
            fontWeight: 900,
            textTransform: 'none',
            boxShadow: 'none'
          }}
        >
          Volver al inicio
        </Button>
      </Stack>
    </Container>
  );
}
